






import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import XTabs from "@/components/SimpleTabs.vue";
import DocumentsTabContent from "@/components/for-documents-view/DocumentsTabContent.vue";
import ContractDocumentsTabContent from "@/components/for-documents-view/ContractDocumentsTabContent.vue";
import ContractActsTabContent from "@/components/for-documents-view/ContractActsTabContent.vue";

@Component({
  components: {
    Page,
    XTabs,
    DocumentsTabContent,
    ContractDocumentsTabContent,
    ContractActsTabContent,
  },
})
class Documents extends Vue {
  titles = ["Документы", "Документы договора", "Акты сверки"];
  components = [DocumentsTabContent, ContractDocumentsTabContent, ContractActsTabContent];

  mounted() {
  }
}

export default Documents;
